// ClientFeedbackPage.jsx
import React, { useState } from "react";
import axios from "axios";
import "./ClientFeedback.css";
import { HostApi } from "../configuration";
import { useNavigate } from "react-router-dom";
const ClientFeedback = () => {

  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [rating, setRating] = useState(0);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      await axios.post(`${HostApi()}/api/Advisor/feedback`,
        {
          name,
          message,
          rating
        }
      );

      alert("Feedback Submitted Successfully");
      navigate("/");
      setName("");
      setMessage("");
      setRating(0);

    } catch (error) {

      console.log(error);

      alert("Something went wrong");
    }
  };

  return (

    <div className="feedback-page">

      <div className="feedback-container">

        <h2>Client Feedback</h2>

        <p>
          We value your feedback. Please share your experience with us.
        </p>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            placeholder="Your Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <textarea
            placeholder="Write your feedback..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          ></textarea>

          <div className="rating-section">

            <label>Rating:</label>

            <div className="stars">

              {[1, 2, 3, 4, 5].map((star) => (

                <span
                  key={star}
                  className={rating >= star ? "active-star" : ""}
                  onClick={() => setRating(star)}
                >
                  ★
                </span>

              ))}

            </div>

          </div>

          <button type="submit">
            Submit Feedback
          </button>

        </form>

      </div>

    </div>
  );
};

export default ClientFeedback;